<!-- Hero Section -->
<app-navbar></app-navbar>

<section class="hero-section">
  <div class="container">
    <div class="hero-content">
      <div class="hero-text">
        
        <h1>{{ pageTitle }}</h1>
        <p class="hero-subtitle">{{ pageSubtitle }}</p>
        
      
        <div class="hero-cta">
          <a class="btn-primary" href="/devis">
            <span>Demander un Devis Gratuit</span>
            <i>→</i>
          </a>
       
        </div>
      </div>
      
      <div class="hero-image">
        <div class="image-wrapper">
          <img src="assets/images/socialmediamannagement.webp" alt="Gestion des réseaux sociaux" />
          <div class="floating-elements">
            <div class="float-card card-1">
              <span class="card-icon">📈</span>
              <span class="card-text">+280% Engagement</span>
            </div>
            <div class="float-card card-2">
              <span class="card-icon">💬</span>
              <span class="card-text">15min Réponse</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>



<!-- Services Section -->
<section class="services-section">
  <div class="container">
    <div class="section-header">
      <h2>Nos Services de Gestion</h2>
      <p>Une approche complète pour développer votre présence sociale</p>
    </div>
    
    <div class="services-grid">
      <div class="service-card" *ngFor="let service of services">
        <div class="service-icon">{{ service.icon }}</div>
        <h3>{{ service.title }}</h3>
        <p class="service-description">{{ service.description }}</p>
        <ul class="service-features">
          <li *ngFor="let feature of service.features">
            <i class="check-icon">✓</i>
            <span>{{ feature }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- Pricing Section -->
<section class="pricing-section" id="pricing">
  <div class="container">
    <div class="section-header">
      <h2>Nos Forfaits de Gestion</h2>
      <p>Choisissez la formule adaptée à vos besoins</p>
    </div>
    
    <div class="pricing-grid">
      <div class="pricing-card" 
           *ngFor="let package of packages" 
           [class.popular]="package.popular">
        <div class="popular-badge" *ngIf="package.popular">
          Le Plus Populaire
        </div>
        
        <div class="package-header">
          <h3>{{ package.name }}</h3>
          
          <p class="package-description">{{ package.description }}</p>
          <span class="package-platforms">{{ package.platforms }}</span>
          <span class="package-posts">{{ package.posts }}</span>
        </div>
        
        <ul class="package-features">
          <li *ngFor="let feature of package.features">
            <i class="check-icon">✓</i>
            <span>{{ feature }}</span>
          </li>
        </ul>
        
        <a class="btn-package" href="/devis">
          Demander un Devis
        </a>
      </div>
    </div>
  </div>
</section>

<!-- Testimonials Section -->
<section class="testimonials-section">
  <div class="container">
    <div class="section-header">
      <h2>Ils Nous Font Confiance</h2>
    </div>
    
    <div class="testimonials-grid">
      <div class="testimonial-card" *ngFor="let testimonial of testimonials">
        <div class="testimonial-rating">
          <i *ngFor="let star of [1,2,3,4,5]">★</i>
        </div>
        <p class="testimonial-text">"{{ testimonial.text }}"</p>
        <div class="testimonial-author">
          <div class="author-image">
            <img [src]="testimonial.image" [alt]="testimonial.name" />
          </div>
          <div class="author-info">
            <div class="author-name">{{ testimonial.name }}</div>
            <div class="author-company">{{ testimonial.company }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section class="cta-section" id="contact">
  <div class="container">
    <div class="cta-content">
      <h2>Prêt à Développer Votre Communauté ?</h2>
      <p>Contactez-nous pour un audit gratuit de vos réseaux sociaux</p>
      <div class="cta-buttons">
        <a class="btn-cta-primary" href="/devis">
          <span>Audit Gratuit</span>
          <i>→</i>
        </a>
        <div class="cta-contact">
          <span>Ou appelez-nous:</span>
          <a href="tel:+33666076455">+33 6 66 07 64 55</a>
        </div>
      </div>
      <div class="cta-email">
        <a href="mailto:Contact@digalchemy.com">Contact&#64;digalchemy.com</a>
      </div>
    </div>
  </div>
</section>


<!-- FAQ Section -->
<section class="faq-section">
  <div class="container">
    <div class="section-header">
      <h2>Questions Fréquentes</h2>
    </div>
    
    <div class="faq-list">
      <div class="faq-item" 
           *ngFor="let faq of faqs" 
           [class.active]="faq.active">
        <div class="faq-question" (click)="toggleFaq(faq.id)">
          <span>{{ faq.question }}</span>
          <i class="faq-icon" [class.rotated]="faq.active">▼</i>
        </div>
        <div class="faq-answer" [class.show]="faq.active">
          <p>{{ faq.answer }}</p>
        </div>
      </div>
    </div>
  </div>
</section>



<footer class="footer-section">
  <div class="footer-container">
    
    <!-- Main Footer Content -->
    <div class="footer-content">
      
      <!-- Section 1: Company Logo & Description -->
      <div class="footer-company">
        <div class="company-logo">
          <img src="assets/images/logo-white.png" alt="Rhillane Logo" />
        </div>
        
        <p class="company-description">
          Digital Alchemy, votre partenaire de confiance pour la création de sites web . 
          Nous transformons vos idées en succès digital avec des solutions innovantes et performantes.
        </p>
        
        <!-- Social Media -->
        <div class="social-media-section">
          <ul style="display: flex; gap: 16px; list-style: none; padding: 0; margin: 0;">
            
            <!-- Facebook -->
            <li style="margin: 0;">
              <a href="https://www.facebook.com/people/Digital-alchemy/61565618420833" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Facebook page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #1877F2; fill: #1877F2;" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </li>
            
            <!-- Behance -->
            <li style="margin: 0;">
              <a href="https://www.behance.net/digitalalchemy2" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Behance page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #1769FF; fill: #1769FF;" viewBox="0 0 24 24">
                  <path d="M0 4.4804V19.243h7.1554c.6613 0 1.3078-.0832 1.9297-.248.6288-.1654 1.1905-.4203 1.6792-.7661.485-.3431.8784-.7804 1.1677-1.3081.2862-.5258.4294-1.1471.4294-1.8641 0-.8784-.2067-1.6309-.6172-2.2506-.4073-.6172-.9897-1.0907-1.7494-1.4161.6388-.3431 1.1139-.8141 1.4285-1.4143.3146-.6002.4719-1.2755.4719-2.0274 0-.7193-.1327-1.3487-.4-1.8888-.2668-.5402-.6343-1.0033-1.0995-1.3914-.4652-.3881-.9712-.6884-1.5186-.8999C8.8135 4.5932 8.2071 4.4804 7.5446 4.4804H0zM15.3486 6.9795h4.7992v1.2755h-4.7992V6.9795zM3.2695 6.9795h3.8893c.9451 0 1.6612.2262 2.1463.6787.4851.4525.7277 1.0632.7277 1.8321 0 .8374-.2768 1.4676-.8323 1.8888-.5555.4212-1.2925.6323-2.2091.6323H3.2695V6.9795zM15.3486 13.2363h4.7992v1.2755h-4.7992v-1.2755zM3.2695 14.2834h4.3172c.6927 0 1.2944.1327 1.8051.3976.5107.2649.9378.6154 1.2755 1.0519.3377.4365.5849.9378.741 1.5044.1561.5666.2342 1.1543.2342 1.7632 0 .7193-.1014 1.3487-.3043 1.8888-.2029.5401-.5107.9949-.9237 1.3648-.4131.3699-.9378.6507-1.5743.8409-.6365.1902-1.3858.2853-2.2477.2853H3.2695v-7.0969z"/>
                </svg>
              </a>
            </li>
            
            <!-- LinkedIn -->
            <li style="margin: 0;">
              <a href="https://www.linkedin.com/company/digital-alchemy-ma/" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our LinkedIn page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #0077B5; fill: #0077B5;" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </li>
            
            <!-- YouTube -->
            <li style="margin: 0;">
              <a href="https://www.youtube.com/@Digital_Alchemy_ma" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our YouTube page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #FF0000; fill: #FF0000;" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </li>
            
            <!-- Instagram -->
            <li style="margin: 0;">
              <a href="https://www.instagram.com/digital_alchemy_ma/" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Instagram page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #E1306C; fill: #E1306C;" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </li>
            
          </ul>
        </div>
      </div>
      
      <!-- Section 2: Contact Information -->
      <div class="footer-contact">
        <h3 class="footer-title">CONTACT</h3>
        
        <div class="contact-info">
          <div class="contact-item">
            <span>+212 690 459 525</span>
          </div>
          <div class="contact-item">
            <span>+33 6 66 07 64 55</span>
          </div>
          <div class="contact-item">
            <span>Digitalalchemyma&#64;gmail.com</span>
          </div>
          <div class="contact-item">
            <span>Contact&#64;digalchemy.com</span>
          </div>
        </div>
        
        <div class="office-locations">
          <div class="office-item">
            <h4>NOTRE BUREAU AU MAROC</h4>
            <p>Bd Dammam, Technopark Casablanca , Maroc .</p>
          </div>
        </div>
      </div>
      
      <!-- Section 3: Services Column -->
      <div class="footer-links">
        <h3 class="footer-title">NOS SERVICES</h3>
        <ul class="footer-list">
          <li><a routerLink="/web">Sites Web</a></li>
          <li><a routerLink="/appweb">Application Web</a></li>
          <li><a routerLink="/publicite">Publicité en ligne</a></li>
          <li><a routerLink="/gestion">Gestion des réseaux sociaux</a></li>
          <li><a routerLink="/design">Design Graphique</a></li>
          <li><a routerLink="/agence">Agence SEO</a></li>
        </ul>
      </div>
      
      <!-- Section 4: Quick Links Column -->
      <div class="footer-links">
        <h3 class="footer-title">LIENS RAPIDES</h3>
        <ul class="footer-list">
          <li><a routerLink="/">Accueil</a></li>
          <li><a routerLink="/apropos">À propos</a></li>
          <li><a routerLink="/contact">Contact</a></li>
          <li><a routerLink="/cgu">Conditions Générales d'Utilisation</a></li>
          <li><a routerLink="/conf">Politique de Confidentialité</a></li>
        </ul>
      </div>
      
    </div>
    
    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <p class="copyright">
          © {{ currentYear }} Digital Alchemy. Tous droits réservés. | 
          <a routerLink="/cgu">Mentions légales</a> | 
          <a routerLink="/conf">Politique des cookies</a>
        </p>
        <div class="footer-bottom-links">
          <a routerLink="/contact">Support</a>
        </div>
      </div>
    </div>
    
  </div>
</footer>